'use strict';

angular.module('ecrd.core')
    .provider('CoreRecordQueries', function() {
        this.$get = ['$window', 'CoreRecordData', function CoreRecordQueries($window, CoreRecordData) {
            return new $window.ShareCrfCore.RecordQueries(CoreRecordData);
        }]
    });
